







import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class ScheduleUser extends Vue {
  @Prop({ required: true }) name!: string;
  @Prop({ required: true }) icon!: string;
}
